import { Chrome } from "lucide-react";
import type { ComponentType } from "react";
import { PlugZap } from "@/components/animate-ui/icons/plug-zap";

/**
 * Map integration providers to icon components
 */
export const PROVIDER_ICONS: Record<string, ComponentType<{ className?: string }>> = {
	google: Chrome,
	// Add more providers as needed
};

/**
 * Get icon component for a provider
 * Returns PlugZap as fallback for unknown providers
 */
export function getProviderIcon(provider: string): ComponentType<{ className?: string }> {
	return PROVIDER_ICONS[provider] || PlugZap;
}

/**
 * Integration icon display type
 */
export type IntegrationIconType =
	| { type: "logo"; url: string }
	| { type: "icon"; Icon: ComponentType<{ className?: string }> };

/**
 * Get integration icon (logo URL or icon component)
 * Prioritizes logo URL if available, falls back to provider icon
 */
export function getIntegrationIcon(provider: string, logoUrl?: string | null): IntegrationIconType {
	if (logoUrl) {
		return { type: "logo", url: logoUrl };
	}
	return { type: "icon", Icon: getProviderIcon(provider) };
}
